module.exports = __webpack_public_path__ + "img/radio-waves-mobile.e2be0dc9.svg";